/* esm.sh - @radix-ui/react-use-callback-ref@1.1.1 */
export * from "/*@radix-ui/react-use-callback-ref@1.1.1/esnext/react-use-callback-ref.mjs";
